<template lang="html">
  <div class="category-form">
    <v-text-field
      label="Title"
      v-model="item.title"
      :rules="[required]"
      autocomplete="off"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  props: {
    item: {},
    required: {}
  }
}
</script>

<style lang="css" scoped>
</style>
